import React, {Fragment} from 'react';
import ReactDOM from 'react-dom';

import classes from './Backdrop.module.scss';

const portalElement = document.getElementById('overlays')! ; // ! is needed for typescript

const Backdrop = () => {  
  return(
    <Fragment>
      {ReactDOM.createPortal(
        <div className={classes.backdrop}></div>, 
        portalElement
      )}      
    </Fragment>
  )
}

export default Backdrop;